export const packageList = [
  {
    name: 'hr',
    activeRule: ['hr'],
    // preload: true
  },
  {
    name: 'hr_cyclopedia',
    activeRule: ['hr-cyclopedia']
  },
  {
    name: 'hr_briefing',
    activeRule: ['hr-briefing']
  },
  {
    name: 'hr_train',
    activeRule: ['hr-train'],
  },
  {
    name: 'legal',
    activeRule: ['lms'],
  },
  {
    name: 'flow',
    activeRule: ['oa'],
    preload: true
  },
  {
    name: 'kts',
    activeRule: ['kts'],
  },
  {
    name: 'tic',
    activeRule: ['tic'],
  },
]

export const remoteModuleConfig = {
  dev: ['hr', 'hr_cyclopedia', 'hr_briefing', 'hr_train', 'legal', 'flow', 'kts', 'tic'],
  stg: ['hr', 'hr_cyclopedia', 'hr_briefing', 'hr_train', 'legal', 'flow', 'kts', 'tic'],
  uat: ['hr', 'hr_cyclopedia', 'hr_briefing', 'hr_train', 'legal', 'flow', 'kts', 'tic'],
  prd: ['hr', 'hr_cyclopedia', 'hr_briefing', 'hr_train', 'legal', 'flow', 'kts', 'tic'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/hr/index.js